import { snackbar } from "@/core/controller/snackbar_controller";
import { headers } from "../const/headers";
import { vehicleDefault } from "../domain/vehicle/vehicle";
import * as XLSX from "xlsx";
import { generateCodeDefault } from "../domain/vehicle/generateCode";
import { vehicleMaintenanceDefault } from '../../vehicleMaintenance/domain/vehicleMaintenance/vehicleMaintenance'
import { hadPermission } from "@/core/domain/model/permission";

class VehicleController {
  context = null;
  headers = headers
  loading = false
  loadingBtnExcel = false
  search = ""
  searchClient = ""
  searchClientInModal = ""
  clientIDToInclude = null
  searchEquipment = ""
  equipmentIDsToInclude = null
  equipmentSelected = []
  dialog = false
  changeDialog = false
  dialogGenerateQrCode = false
  form = vehicleDefault()
  formCode = generateCodeDefault({})
  statusPaginated = 1
  statusSelected = 1
  statusList = [
    { text: "Todos", value: 0 },
    { text: "Ativo", value: 1 },
    { text: "Inativo", value: 2 },
  ]
  dialogVehicleMaintenance = false
  maintenances = []
  formMaintenance = vehicleMaintenanceDefault()
  costResponsibility = ["Cliente", "Empresa"]

  code = {}
  equipments = []
  dialogGenerateQrCodeCreated = false

  reason = ["Instalação nova", "Manutenção no veículo", "Bloqueado", "Manutenção externa"]

  vehiclePagination = {
    total: 0,
    items: []
  }

  options = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["id"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  clientPagination = {
    total: 0,
    items: []
  }

  clientOptions = {
    page: 1,
    itemsPerPage: 100,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  equipmentPagination = {
    total: 0,
    items: []
  }

  equipmentOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  constructor(
    context,
    fetchVehicleUseCaseImpl,
    createVehicleUseCaseImpl,
    changeVehicleUseCaseImpl,
    deleteVehicleUseCaseImpl,
    fetchClientUseCaseImpl,
    fetchEquipmentUseCaseImpl,
    refreshUseCaseImpl,
    createReleaseUseCaseImpl,
    createVehicleMaintenanceUseCaseImpl,
  ) {
    this.context = context;
    this.fetchVehicleUseCaseImpl = fetchVehicleUseCaseImpl
    this.createVehicleUseCaseImpl = createVehicleUseCaseImpl
    this.changeVehicleUseCaseImpl = changeVehicleUseCaseImpl
    this.deleteVehicleUseCaseImpl = deleteVehicleUseCaseImpl
    this.fetchClientUseCaseImpl = fetchClientUseCaseImpl
    this.fetchEquipmentUseCaseImpl = fetchEquipmentUseCaseImpl
    this.refreshUseCaseImpl = refreshUseCaseImpl
    this.createReleaseUseCaseImpl = createReleaseUseCaseImpl
    this.createVehicleMaintenanceUseCaseImpl = createVehicleMaintenanceUseCaseImpl
  }

  async paginate() {
    this.loading = true
    try {
      this.vehiclePagination = await this.fetchVehicleUseCaseImpl(this.options, this.search, this.statusSelected)
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false
    }
  }

  async clientPaginate() {
    try {
      this.clientPagination = await this.fetchClientUseCaseImpl(this.clientOptions, this.searchClient || this.searchClientInModal, this.statusPaginated, this.clientIDToInclude)
    } catch (error) {
      console.log(error);
    }
  }

  async equipmentPaginate() {
    try {
      this.equipmentPagination = await this.fetchEquipmentUseCaseImpl(this.equipmentOptions, this.searchEquipment, this.statusPaginated, this.equipmentIDsToInclude)
    } catch (error) {
      console.log(error);
    }
  }

  async open() {
    this.dialog = true
    this.clientIDToInclude = null
    this.form = vehicleDefault()
    this.searchClientInModal = ""
    this.equipmentSelected = []
    this.equipmentIDsToInclude = null 

    await this.equipmentPaginate()
    }

  close() {
    this.context.$refs.crud.resetValidation()
    this.dialog = false
    this.form = vehicleDefault({})
    this.searchClientInModal = ""
    this.clientIDToInclude = null
    this.equipmentSelected = []
    this.equipmentIDsToInclude = null
  }

  openCodeGenerator(item) {
    this.equipments = item.equipments;
    if (item.equipments.length > 1) {
      for (const equipment of this.equipments) {
        if (equipment.mac == null) {
          equipment.mac = equipment.equipmentTypeID === 1 ? 
          "Jammer Principal (sem mac)" : 
          "Auxiliar";
        }
      }

      const firstEquipment = this.equipments.find(item => item.equipmentTypeID === 1) || this.equipments[0];


      this.formCode = generateCodeDefault({ vehicleID: item.id, equipmentID: firstEquipment, serial: firstEquipment.name })
      this.dialogGenerateQrCode = true
      return
    }

    if (item.equipments.length == 1) {
      this.formCode = generateCodeDefault({ vehicleID: item.id, equipmentID: item.equipments[0], serial: item.equipments[0].name })
      this.dialogGenerateQrCode = true
      return
    }

    snackbar.show({ message: "Veículo sem equipamentos cadastrados!", color: "#ff0000", timeout: 3000 })
  }

  async create() {
    if (this.context.$refs.crud.validate()) {
      try {
        this.loading = true
        /*         const equipmentIds = []
                this.form.equipments.forEach(el => equipmentIds.push(el.id))
                this.form.equipments = equipmentIds */
        this.form.equipments = [...this.equipmentSelected]
        
      if (this.form.id != 0) {
        await this.changeVehicleUseCaseImpl(this.form.id, this.form)
        snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
      } else {
        await this.createVehicleUseCaseImpl(this.form)
        snackbar.show({ message: "Adicionado com sucesso!!!", color: "#008000", timeout: 3000 })
      }

        await this.refreshUseCaseImpl()
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
      } finally {
        this.paginate()
        this.loading = false
        this.close()
      }
    }
  }

  async generateCode() {
    if (this.context.$refs.crudGenerateCodeVehicle.validate()) {
      try {
        this.loading = true
        this.formCode.equipmentID = this.formCode.equipmentID.id
        this.code = await this.createReleaseUseCaseImpl(this.formCode)
        this.dialogGenerateQrCodeCreated = true

        setTimeout(() => {
          this.dialogGenerateQrCodeCreated = false
          this.code = {}
        }, 15000)
      } catch (error) {
        snackbar.show({ message: error, color: "#ff0000", timeout: 3000 })
      } finally {
        this.paginate()
        this.loading = false
        this.dialogGenerateQrCode = false
      }
    }
  }

  async change(item) {
    const isAdmin = hadPermission(0, 0)

    if (isAdmin) {
      this.dialog = true
      this.form = { ...item }

      this.searchClientInModal = item.client
      this.clientIDToInclude = item.clientID

      this.clientPagination.items = [{ id: item.clientID, name: item.client }]
      
      this.equipmentSelected = [...this.form.equipments]
      
      this.equipmentIDsToInclude = this.equipmentSelected.length > 0 
        ? this.equipmentSelected.map(e => e.id).join(',') 
        : null
      
      const promises = [
        this.equipmentPaginate(),
        this.clientPaginate()
      ]

      await Promise.all(promises)
    } else if (hadPermission(4,2)) {
      this.dialog = true
      this.form = { ...item }
      
      this.equipmentSelected = [...this.form.equipments]
      
      this.equipmentIDsToInclude = this.equipmentSelected.length > 0 
        ? this.equipmentSelected.map(e => e.id).join(',') 
        : null
      
      const promises = [
        this.equipmentPaginate()
      ]

      await Promise.all(promises)
    }
  }

  /*   async delete(item) {
      try {
        const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
        if (confirm) {
          await this.deleteVehicleUseCaseImpl(item.id)
          this.paginate()
          snackbar.show({ message: "Resgistro excluído com sucesso!", color: "#008000", timeout: 1000 })
        }
      } catch (error) {
        snackbar.show({ message: error.toString() })
      }
    } */

  changeSerialName(item) {
    this.formCode.serial = item.name
  }

  openVehicleMaintenance(item) {
    this.formMaintenance = vehicleMaintenanceDefault();
    this.formMaintenance.vehicleID = item.id;
    this.formMaintenance.clientID = item.clientID; 
    this.formMaintenance.plate = item.plate;
    this.formMaintenance.isolated = item.isolated;
    this.dialogVehicleMaintenance = true;
  }

  handleCostChange(value) {
    if (!value) {
      this.formMaintenance.cost = null;
      this.formMaintenance.costFormatted = "";
      this.formMaintenance.costResponsibility = null;
    }
  }

  handleCostInput(value) {
    const numericValue = value.replace(/\D/g, '');
    
    if (numericValue === '') {
      this.formMaintenance.cost = 0;
      this.formMaintenance.costFormatted = '';
      return;
    }
    
    this.formMaintenance.cost = parseInt(numericValue) || 0;
    
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    this.formMaintenance.costFormatted = formatter.format(this.formMaintenance.cost / 100);
  }

  validateNumberInput(evt) {
    const keyCode = evt.keyCode ? evt.keyCode : evt.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { 
      evt.preventDefault();
    }
  }

  async saveVehicleMaintenance() {
    if (this.context.$refs.maintenanceForm.validate()) {
      try {
        this.loading = true;

        const formData = { ...this.formMaintenance };

        if (!formData.hadCost) {
          formData.cost = null;
          formData.costResponsibility = null;
        }

        await this.createVehicleMaintenanceUseCaseImpl(formData);
        snackbar.show({ 
          message: 'Registro adicionado com sucesso!', 
          color: "#008000", 
          timeout: 3000 
        });

      } catch (error) {
        snackbar.show({ 
          message: error.toString(), 
          color: "#ff0000", 
          timeout: 3000 
        });
      } finally {
        this.paginate();
        this.loading = false;
        this.dialogVehicleMaintenance = false;
      }
    }
  }

  watchOptions() {
    this.paginate()
  }
  watchSearch() {
    this.paginate()
  }
  watchClientOptions() {
    this.clientPaginate()
  }
  watchClientSearch() {
    this.clientPaginate()
  }
  watchClientSearchInModal() {
    this.clientPaginate()
  }
  watchEquipmentOptions() {
    this.equipmentPaginate()
  }
  watchEquipmentSearch() {
    this.equipmentPaginate()
  }

  async exportExcel() {
    try {
      const heading = [['ID', 'PLACA', 'ID CLIENTE', 'ATIVO', 'MODELO', 'ANO', 'EXCLUIDO', 'DATA CRIACAO', 'CLIENTE', 'EQUIPAMENTOS', 'DESCRICAO','ISOLADO']];
      this.loadingBtnExcel = true
      const paginate = { ...this.options }
      paginate.itemsPerPage = 30000
      const data = await this.fetchVehicleUseCaseImpl(paginate, "")

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, heading);
      XLSX.utils.sheet_add_json(ws, data.items.map((item) => {
        const i = JSON.parse(JSON.stringify(item))
        return i
      }), { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws, 'vehicle');

      XLSX.writeFile(wb, `veiculos.xlsx`);
    } catch (error) {
      snackbar.show({ message: error.toString() })
    } finally {
      this.loadingBtnExcel = false
    }
  }

  changeStatus() {
    this.paginate()
  }

  isSelected(item) {
    return this.equipmentSelected.some((el) => el.id === item.id);
  }
  toggleItem(item) {
    if (this.equipmentSelected.some((el) => el.id === item.id)) {
      this.removeItem(item);
    } else {
      this.equipmentSelected.push(item);
    }
  }
  removeItem(item) {
    if (this.equipmentSelected.some((el) => el.id == item.id)) {
      let index = this.equipmentSelected.map((e) => e.id).indexOf(item.id);
        if (index > -1) {
          this.equipmentSelected.splice(index, 1);
        }
      }
    }
}

export default VehicleController